/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const decisionRatedByDtoSchema = z.object({
  name: z.optional(z.string()),
  avatarInitials: z.optional(z.string()),
  comment: z.string().nullish(),
  timestamp: z.optional(z.string()),
});
